/* eslint-disable @typescript-eslint/no-unused-vars */
// CSS
import { getCurrGeoLevelName, isAddedToCompare, useMapHelpers } from '../../helpers';
import { compareListState, geoState, ptypeState, selectedTabState, userCurrencyState } from '../../states';
import '../../styles/main.css';

// Utilities
import { Heading, TypographyColor, TypographyType, Body, BodyType, BodyColor, ProgressBar, Button, ButtonTheme, ButtonVariant, ButtonSize } from '../../ui-elements';
import { useRecoilValue } from 'recoil';
import { AddToCompare } from './AddToCompare';
import { useMemo } from 'react';
import { RESET_FIELD_ARRAY } from '../../constants';
import { useSearchParams } from 'react-router-dom';

interface HoverPopupProps {
    classname: string;
    properties: any;
    isGeoFocused: boolean;
    handleClose: () => void;
    handleNavigation: (e: any, navigattion: any) => void;
    carousel?: {
        features: any[];
        currentIndex: number;
    } | null;
    onCarouselNext?: () => void;
    onCarouselPrev?: () => void;
}

export const HoverPopup: React.FC<HoverPopupProps> = ({ classname, properties, isGeoFocused, handleClose, handleNavigation, carousel, onCarouselNext, onCarouselPrev }) => {
    const selCurrency = useRecoilValue(userCurrencyState);
    const compareList = useRecoilValue(compareListState);
    const selectedTab = useRecoilValue(selectedTabState);
    const selected = useRecoilValue(geoState);
    const [searchParams] = useSearchParams();
    const catchmnet = searchParams.get('catchment');
    const { getCurrencyWithSymbol } = useMapHelpers();
    const pType = useRecoilValue(ptypeState);

    const geoCode = useMemo(() => {
        const { country, state, district, sub_district, village } = selected;
        const geo_id = village || sub_district || district || state || country;
        return Number(geo_id);
    }, [selected]);

    const geoLevelForCompare = useMemo(() => {
        const { country, state, district, sub_district } = selected;

        if (catchmnet) return 'villages';

        if (country == geoCode || state == geoCode) return 'districts';
        else if (district == geoCode) {
            if (selectedTab === 5) return 'pincodes';
            return 'subdistricts';
        }
        else if (sub_district == geoCode) return 'villages';
        return null;
    }, [geoCode, selected, selectedTab]);

    const handleCloseCard = (e: any) => {
        e.stopPropagation();
        handleClose();
    }

    return (
        <div
            className={`rounded row h-auto ${classname} cursor-pointer bg-white padding-top-bottom-2 pe-none`}
            style={{ transform: "scale(0.8)" }}
        // onClick={(e) => handleNavigation(e, properties.geoLevel, properties.geoId)}
        >
            <div className={`d-flex m-0 p-2 col-12 ${!isGeoFocused ? 'flex-row align-items-center row' : 'align-items-center justify-content-between'}`}>
                <Heading
                    // title={`${properties?.geoName}${properties.overlap ? ' *' : ''}`}
                    title={`${properties?.geoName}`}
                    colour={TypographyColor.primary}
                    type={TypographyType.h5}
                    classname='m-0 p-0 text-start'
                />
                {isGeoFocused && <span className="material-symbols-outlined fs-16 color-black m-0 p-0 cursor-pointer pe-auto" onClick={(e) => handleCloseCard(e)}>close</span>}
            </div>
            <hr />
            {/* {(properties?.districtsCovered && properties?.districtsCovered?.coverage && properties?.districtsCovered?.total && !selected.sub_district) &&
                <div className="d-flex m-0 p-3 col-12 flex-column align-items-start justify-content-center padding-top-bottom-2 lh-sm">
                    <div className="col-12 d-flex justify-content-start align-items-center p-0 padding-bottom-2 m-0">
                        <Heading
                            title={`${properties?.districtsCovered?.coverage}/${properties?.districtsCovered?.total}`}
                            type={TypographyType.h6}
                            colour={TypographyColor.primary}
                            classname='text-start p-0 padding-right-1'
                        />
                        <Body
                            type={BodyType.p3}
                            color={BodyColor.primary}
                            classname="p-0 no-extra-line-height"
                        >
                            {`Districts Covered`}
                        </Body>
                    </div>
                    <ProgressBar coverage={properties?.districtsCovered} classname='bg-poi' />
                </div>
            } */}
            <div className="d-flex m-0 p-3 col-6 flex-column align-items-start justify-content-center padding-top-3 padding-bottom-0 lh-sm">
                <Heading
                    title={properties?.ehHouseholds || '--'}
                    colour={TypographyColor.primary}
                    type={TypographyType.h6}
                    classname='m-0 text-start p-0'
                />
                <Body
                    type={BodyType.p3}
                    color={BodyColor.secondary}
                    classname="p-0"
                >
                    EH
                </Body>
            </div>
            <div className="d-flex m-0 p-3 col-6 flex-column align-items-start justify-content-center padding-top-3 padding-bottom-0 lh-sm">
                <Heading
                    title={getCurrencyWithSymbol(properties?.avgCtv, selCurrency)}
                    colour={TypographyColor.primary}
                    type={TypographyType.h6}
                    classname='m-0 text-start p-0'
                />
                <Body
                    type={BodyType.p3}
                    color={BodyColor.secondary}
                    classname="p-0"
                >
                    Avg CTV
                </Body>
            </div>
            <div className="d-flex m-0 p-3 col-6 flex-column align-items-start justify-content-center padding-top-bottom-3 lh-sm">
                <Heading
                    title={
                        properties?.pointsOfInterest != null ? (
                            <>
                                {properties.pointsOfInterest}
                                {/* {((selected?.sub_district && properties?.poi_overlap) || (properties?.poi_overlap && selected?.district && selectedTab == 5) || (catchmnet && properties?.poi_overlap)) && <sup>#</sup>} */}
                            </>
                        ) : (
                            "--"
                        )
                    }
                    colour={TypographyColor.primary}
                    type={TypographyType.h6}
                    classname='m-0 text-start p-0'
                />
                <Body
                    type={BodyType.p3}
                    color={BodyColor.secondary}
                    classname="p-0"
                >
                    PoI
                </Body>
            </div>
            <div className="d-flex m-0 p-3 col-6 flex-column align-items-start justify-content-center padding-top-bottom-3 lh-sm">
                <Heading
                    title={properties?.population || '--'}
                    colour={TypographyColor.brown}
                    type={TypographyType.h6}
                    classname='m-0 text-start p-0'
                />
                <Body
                    type={BodyType.p3}
                    color={BodyColor.secondary}
                    classname="p-0"
                >
                    Population
                </Body>
            </div>
            <div className={`d-flex m-0 p-3 col-12 flex-column align-items-start justify-content-center padding-top-bottom-3 lh-sm border-top`}>
                <Heading
                    title={properties?.mbp_count || 'None'}
                    colour={TypographyColor.primary}
                    type={TypographyType.h6}
                    classname='m-0 text-start p-0'
                />
                <Body
                    type={BodyType.p3}
                    color={BodyColor.secondary}
                    classname="p-0"
                >
                    My Business Presence
                </Body>
            </div>
            
            {properties.overlap &&
                <div className="d-flex m-0 p-0 col-12 flex-column align-items-start justify-content-center lh-sm border-top">
                    <Body
                        type={BodyType.p3}
                        color={BodyColor.secondary}
                        classname="p-3 fs-9 padding-bottom-2"
                    >
                        {selected?.sub_district
                            ? <><sup>*</sup> Village lies partially outside of your selected district</>
                            : <><sup>*</sup> PIN Code lies partially outside of your selected district</>}
                    </Body>
                </div>}
            {((properties.poi_overlap && selected?.sub_district) || (properties.poi_overlap && selected?.district && selectedTab == 5) || (catchmnet && properties.poi_overlap)) &&
                <div className="d-flex m-0 p-3 col-12 flex-column align-items-start justify-content-center padding-top-0 lh-sm">
                    <Body
                        type={BodyType.p3}
                        color={BodyColor.secondary}
                        classname="p-0 fs-9"
                    >
                        {`POIs of the ${catchmnet ? "villages" : selected?.sub_district ? "villages" : "pincodes"} are partially covered`}
                    </Body>
                </div>}
           
            {isGeoFocused &&
                <>
                    <hr className='p-0 m-0' />
                    <div className={`d-flex align-items-center justify-content-between p-2 m-0 w-100 pe-auto ${properties.overlap || properties.poi_overlap ? 'padding-top-bottom-3' : 'padding-top-3'}`}>
                        <AddToCompare
                            isAddedToCompare={isAddedToCompare(properties.geoId, compareList,pType)}
                            geoId={properties.geoId}
                            level={properties.geoLevelNumber}
                            count={compareList?.[geoLevelForCompare!]?.length}
                            tooltipPosition='bottom'
                            showNodeWithoutHover={true}
                            parent_id={Number(selected.district)}
                        />
                        <Button
                            theme={ButtonTheme.primary}
                            variant={ButtonVariant.bordered}
                            size={ButtonSize.xsmall}
                            type="button"
                            classname='fs-12'
                            onClick={(e) => handleNavigation(e, properties.navigation)}
                        >
                            Visit Region
                        </Button>
                    </div>
                </>}
                {/* <hr className='p-0 m-0' /> */}

                 {/* Carousel Navigation */}
            {isGeoFocused && carousel && carousel.features.length > 1 && (
                <div className="d-flex align-items-center justify-content-between gap-1 p-auto m-0"
                style={{backgroundColor:"white",position:"absolute", bottom:"-18%",left:"30%", margin:"0 auto", borderRadius:"8px", width:"45%"}}
                >
                    <Button
                        theme={ButtonTheme.primary}
                        variant={ButtonVariant.transparent}
                        type='button'
                        disabled={carousel.currentIndex === 0}
                        onClick={(e) => {
                            e.stopPropagation();
                            onCarouselPrev && onCarouselPrev();
                        }}
                        classname='p-0 m-0 h-auto w-auto pe-auto'
                    >
                        <span className="material-symbols-outlined fs-16 p-0 m-0 padding-top-2">keyboard_arrow_left</span>
                    </Button>
                    <Heading
                        title={`${carousel.currentIndex + 1} of ${carousel.features.length}`}
                        type={TypographyType.h7}
                        colour={TypographyColor.primary}
                        classname='m-0 p-0'
                    />
                    <Button
                        theme={ButtonTheme.primary}
                        variant={ButtonVariant.transparent}
                        type='button'
                        disabled={carousel.features.length === carousel.currentIndex + 1}
                        onClick={(e) => {
                            e.stopPropagation();
                            onCarouselNext && onCarouselNext();
                        }}
                        classname='p-0 h-auto w-auto pe-auto'
                    >
                        <span className="material-symbols-outlined fs-16 p-0 m-0 padding-top-2">keyboard_arrow_right</span>
                    </Button>
                </div>
            )}
        </div>
    );
};

